var card_default = {
  "cardWrapper": "EI71t",
  "cardGap": "YNe-6",
  "cardHeaderContainer": "KynnD",
  "cardContainer": "_8FK9B",
  "fluid": "Quwac",
  "selectionSvg": "NOaTc",
  "selectionRect": "EVZrV",
  "selectionRectActive": "Ay70e",
  "last": "_37nDR",
  "cardGapAddButtonWrapper": "YJH4O",
  "mergeHover": "_82kCg",
  "cardContent": "uRYra",
  "fluidContent": "j2xv3",
  "cardBoundaryLineWrapper": "_-8sw4",
  "visible": "_--v-I",
  "cardBoundaryLineContent": "NmppK",
  "hovered": "iAe18",
  "cardBoundaryLine": "MFEAQ",
  "cardBoundaryWarning": "a6v3h"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
